import { FC } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS, PaperAirplane } from '@connect-x-app/shared-ui';

import './NoPermissions.scss';

type Props = {
  description: string;
  title: string;
};

export const NoPermissions: FC<Props> = ({ description, title }) => {
  return (
    <div className="login-feedback">
      <img alt="logo" className="login-feedback__info" height={240} src={PaperAirplane} />
      <Text as="h1" className="login-feedback__info" color={COLORS.zulu.$08} size="XL" weight="bold">
        {title}
      </Text>
      <Text as="p" className="login-feedback__info" color={COLORS.zulu.$08} size="SM">
        {description}
      </Text>
    </div>
  );
};
